import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Hero from "@/components/Hero";
import Nav from "@/components/Nav";
import ExitIntent from "@/components/ExitIntent";
import TriDelivery from "@/components/TriDelivery";
import ProductDetails from "@/components/ProductDetails";
import AboutBrand from "@/components/AboutBrand";
import InstagramFeed from "@/components/InstagramFeed";
import ShopBar from "@/components/ShopBar";
import Privacy from "@/pages/Privacy";
import ProductPage from "@/pages/Product";

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-center"
        theme="light"
        toastOptions={{
          style: {
            background: "#f4f1ea",
            border: "1px solid rgba(27,23,53,0.16)",
            color: "#1b1735",
          },
        }}
      />
      <Nav />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <TriDelivery />
              <ProductDetails />
              <InstagramFeed />
              <AboutBrand />
              <ShopBar />
              <ExitIntent />
              <div
                className="py-8 text-center"
                style={{ color: "var(--paper-faint)", background: "var(--cream)", paddingBottom: "88px" }}
                data-testid="site-footer"
              >
                <p className="text-[0.62rem] track-sm uppercase" style={{ color: "var(--paper-dim)" }}>
                  Evove Skincare Private Limited
                </p>
                <p className="mt-1 text-[0.56rem] track-sm uppercase">
                  Skin &amp; Hair Ageing Co
                </p>
              </div>
            </>
          }
        />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/skin-longevity-triple-serum" element={<ProductPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
